import React from "react";
import withView from '../../cmn/docAutomation/withView';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormLink from '../../../library/form/components/FormLink';
import FormLabel from '../../../library/form/components/FormLabel'
import FormTitle from '../../../library/form/components/FormTitle';
import FormWrapper from '../../../library/form/components/FormWrapper';
import FormStatus from '../../../library/form/components/FormStatus';
import DocFormReview from "../../cmn/docReviewStatus/DocFormReview";
import { UiView, UiViewHeading, UiTitle, UiViewContent, UiGridColOne, UiCol } from "../../../library/layout/Index";

const invExpTrnFooter = (props) => {
    const { formObject } = props;
    return (
        <UiView>

            <UiViewHeading>
                <UiTitle>
                    <FormTitle formObject={formObject} value='Transaction Summary' />
                </UiTitle>
            </UiViewHeading>
            <UiViewContent>
                <UiGridColOne>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="ID" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docID" }} className='uiVal uiHighlightKey' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docCode" }} value="Document Code" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docCode" }} className='uiVal uiHighlightKey' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docDate" }} value="Document Date" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docDate" }} />
                            </li>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "masterLink" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "masterLink" }} value="Master" />
                                </span>
                                <FormLink formObject={formObject} rowKey="" className="uiLink"
                                    action={{
                                        paramName: "masterLink",
                                        actionId: "show", 
                                        containerKey: "popup"
                                    }}
                                    linkProp={{ target: "_blank" }}
                                ></FormLink>
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "reference" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "reference" }} value="Reference" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "reference" }} className='uiVal' />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "docStatus" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docStatus" }} value="Document Status" />
                                </span>
                                <FormStatus formObject={formObject} rowKey="" headerKey="docStatus"/>
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "finStatus" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "finStatus" }} value="Finance Status" />
                                </span>
                                <FormStatus formObject={formObject} rowKey="" headerKey="finStatus"/>
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "WorkflowStatus" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "WorkflowStatus" }} value="Review Status" />
                                </span>
                                <DocFormReview formObject={formObject} />
                                <span></span>
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "qcStatus" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qcStatus" }} value="QC Status" />
                                </span>
                                <FormStatus formObject={formObject} rowKey="" headerKey="qcStatus"/>
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "parentLink" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "parentLink" }} value="" />
                                </span>
                                <FormLink formObject={formObject} rowKey="" className="uiLink"
                                    action={{
                                        paramName: "parentLink",
                                        actionId: "show", 
                                        containerKey: "popup"
                                    }}
                                    linkProp={{ target: "_blank" }}
                                ></FormLink>
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "masterLink" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "masterLink" }} value="" />
                                </span>
                                <FormLink formObject={formObject} rowKey="" className="uiLink"
                                    action={{
                                        paramName: "masterLink",
                                        actionId: "show", 
                                        containerKey: "popup"
                                    }}
                                    linkProp={{ target: "_blank" }}
                                ></FormLink>
                            </FormWrapper>
                        </ul>
                        <FormWrapper customWrapper="ul" formObject={formObject} rowKey="" action={{ paramName: "costContainer" }} >
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currency" }} value="Currency" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "currency" }} className='uiVal uiHighlightKey' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "exchangeRate" }} value="Exchange Rate" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "exchangeRate" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl uiHighlightBlue">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "amountToPay" }} value="Transaction Value" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "amountToPay" }} className='uiVal uiHighlightBlue' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "lastPaidDate" }} value="Last Paid Date" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "lastPaidDate" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "outstanding" }} value="Outstanding" />
                                </span>
                                <FormROValue  formObject={formObject} rowKey="" action={{ paramName: "outstanding" }} className="uiVal uiHighlightBlue" />
                            </li>
                        </FormWrapper>
                    </UiCol>
                </UiGridColOne>
            </UiViewContent>
        </UiView>
    )
}

export default withView(invExpTrnFooter, "invTrnFooter", "")